import React from 'react';
import { Text } from '../../../atoms';
import { DropzoneSupportedFormatsProps } from '../Dropzone.types';
import { useDropzoneContext } from '../Dropzone';

const DropzoneSupportedFormats = (props: DropzoneSupportedFormatsProps) => {
  const { accept } = useDropzoneContext();
  const supportedFormats = Object.values(accept).reduce((acc, curr) => {
    return acc.concat(curr);
  }, []).join(', ');
  return <Text {...props}>
    Supported formats: {supportedFormats}
  </Text>;
};

export default DropzoneSupportedFormats;
